<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M13.29 4.29A7.7 7.7 0 0 0 5.57 12H3l3.33 3.33.06.12L9.86 12H7.29a6 6 0 1 1 1.76 4.23l-1.22 1.22a7.71 7.71 0 1 0 5.45-13.17"
      />
    </svg>
  </span>
</template>
